package core.util

import com.github.ajalt.colormath.model.RGB

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 03.11.22
 * Author : mariorosshirt
 */
object ColourHelper {

    fun getContrastIsBlack(hex: String): Boolean {
        val color = RGB(hex)
        val y = (color.redInt * 299 + color.greenInt * 587 + color.blueInt * 114) / 1000
        return y >= 128
    }

}